import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getProjectService } from '../../backend';
import { ProjectDetails } from '../../types';
import { handleSetMixpanelUserGroups } from '../../backend/tracking';

// Query keys
export const projectKeys = {
  all: ['projects'] as const,
  lists: () => [...projectKeys.all, 'list'] as const,
  list: () => [...projectKeys.lists()] as const,
};

/**
 * Hook to fetch projects list
 */
export function useProjects(
  options?: Omit<UseQueryOptions<ProjectDetails[], Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<ProjectDetails[], Error>({
    queryKey: projectKeys.list(),
    queryFn: async () => {
      const { data: { projects } } = await getProjectService().listProjects();
      const projectsList = projects as ProjectDetails[];
      
      // Track user groups for analytics
      handleSetMixpanelUserGroups(projectsList.map(item => item.id));
      
      return projectsList;
    },
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  });
}
